import { DatePipe } from "@angular/common";
import { Component, Injector, OnChanges, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BaseEntityComponent, BaseEntityConfig, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ROLE_AGENTE_ENVIO, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { SolicitacaoDevolucaoHonra } from "src/app/model/devolucao-honra.model";
import { OcorrenciaValidacaoVO } from "src/app/shared/ocorrencia-validacao.vo";
import { PermissaoService } from 'src/app/shared/permissao.service';
import { RemoverAlertasService } from "src/app/shared/services/remover-alertas.service";
import { SolicitacaoDevolucaoHonraService } from "../devolucao-honra.service";
import { TermosEnvioDevolucaoHonraModalComponent } from "./termos-envio-devolucao-honra-modal.component";

@Component({
    templateUrl: './devolucao-honra-cadastro.component.html',
    standalone: false
})
export class DevolucaoHonraCadastroComponent extends BaseEntityComponent<SolicitacaoDevolucaoHonra> 
    implements OnInit, OnChanges {    
    
    private agentesFinanceiros:AgenteFinanceiro[]=[];
    private ocorrencias: OcorrenciaValidacaoVO[] = [];
    public formularioValido: boolean;

    public devolucaoPeloGestor: boolean;
    public solicitacaoDevolucao = new SolicitacaoDevolucaoHonra();
    public sistemaSelecionado: string = 'CL';
    public cnpjAgente: string;
    public modoEdicao: boolean = true;
    public podeEnviarSolicitacaoDevolucao: boolean;
    public usuarioAgenteFinanceiro: boolean;

    constructor(
        protected injector: Injector,
        protected devolucaoService: SolicitacaoDevolucaoHonraService,
        private bnUsuarioService: BnUsuarioService,
        private removerAlertasService: RemoverAlertasService,
        private datePipe:DatePipe,
        private permissaoService: PermissaoService,
        private activatedRoute:ActivatedRoute,
        private _modalService: NgbModal,) {

        super(devolucaoService, new BaseEntityConfig('/devolucao/cadastro'));
        this.config.rotaLista = '/devolucao/pesquisa';
        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
    }

    ngOnInit() {
        this.bnUsuarioService.usuario$.subscribe(usuario => {
            this.cnpjAgente = usuario && usuario.cnpj;
          });

        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            this.podeEnviarSolicitacaoDevolucao = resp && (resp[ROLE_AGENTE_ENVIO] || resp[ROLE_GESTOR_ENVIO]);
           
            if (this.podeEnviarSolicitacaoDevolucao) {
                this.usuarioAgenteFinanceiro = resp[ROLE_AGENTE_ENVIO]; 

                if(this.usuarioAgenteFinanceiro) {
                    this.bnUsuarioService.usuario$.subscribe(usuario => {
                        this.solicitacaoDevolucao.cnpjAgenteFinanceiro  = usuario?.cnpj;
                    });
                }

            } else {
                let mensagem = 'Usuário sem permissão para realizar esta ação';
                this.messageService.addMessage({
                    title: 'Erro',
                    type: 'CRUD_OPERATION',
                    level: messageLevel.ERROR,
                    message: mensagem
                });
            }
         
          });

          this.activatedRoute.queryParams.subscribe(params => { 
              if(JSON.stringify(params) !== '{}') {
                   
                  this.sistemaSelecionado = params['sistema'];
                  if (this.sistemaSelecionado === 'CL') {                      
                    this.solicitacaoDevolucao.idOperacaoExterno = params['idOperacaoAgenteCreditoLivre'];
                  } else {
                    this.solicitacaoDevolucao.sistemaRepasse = ('' + params['sistema']);
                    this.solicitacaoDevolucao.contratoRepasse = params['contratoRepasse'];
                  }
              }          
          });
    }

    ngOnChanges() {
        //NgOnChanges Nao funciona
        this.formularioValido = this.executarValidacoesPreliminares();
    }

    atribuiSistema(sistema: string) {
        this.solicitacaoDevolucao.sistemaRepasse = sistema == 'CL' ? undefined : sistema;
        if(sistema == '89' || sistema == '15'){
            this.solicitacaoDevolucao.idOperacaoExterno = null;
        } else {
            this.solicitacaoDevolucao.contratoRepasse = null;
        }
    }

    executarValidacoesPreliminares() {

        // TODO: este codigo aqui nao esta funcionando

        let sucesso: boolean = true;

        if (!this.solicitacaoDevolucao.sistemaRepasse &&
            !this.solicitacaoDevolucao.idOperacaoExterno) {
            this.exibirErro('É necessário informar id externo da operação para operações Crédito Livre');
            sucesso = false;
        }

        return sucesso;
    }

    salvar() {
        this.solicitacaoDevolucao.dataEnvio = this.datePipe.transform(new Date(),"yyyy-MM-ddTHH:mm",'pt');
        
        this.devolucaoService.salvarDevolucao(this.solicitacaoDevolucao, false)
            .subscribe(limiteRetornado => {
                this.setModel(limiteRetornado);
                this.exibeMensagemSucesso();
            }, error => {
                console.log(error);
                this.ocorrencias = this.devolucaoService.ocorrencias;
            }); 
    }

    exibeMensagemSucesso(): void {
        this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Solicitação de devolução enviada com sucesso.'
        });
    }

    exibirErro(erro: string) {
        this.messageService.addMessage({
            title: 'Erro',
            type: 'CRUD_OPERATION',
            level: messageLevel.ERROR,
            message: erro
          });
    }

    public verificaTermos(): void{
        const modalRef = this._modalService.open(TermosEnvioDevolucaoHonraModalComponent, {
            windowClass: 'modal-dialog-md',
            backdrop: 'static',
            size:'lg'
          });
      
          modalRef.componentInstance.callback = (respModal) => {
              if(respModal == true){
                this.salvar();
              }
          };
    }
}